// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f5412b4b","351":"30d91560","455":"348cf833","977":"15a15d6d"}[chunkId] + ".chunk.js";
};